import { render } from "./BatchInstructionsModal.vue?vue&type=template&id=6e8552de"
const script = {}

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__